<script setup lang="ts">
import { computed, ref, onMounted } from "vue";
import { ChartData, ChartOptions } from "chart.js/auto";
import Chart from "../../base-components/Chart";
import { getColor } from "../../utils/colors";

const refresh = ref(0);
onMounted(() => {
  refresh.value++;
});

window.addEventListener("updateTheme", (event) => {
  refresh.value++;
});

const props = defineProps<{
  width?: number;
  height?: number;
}>();

const chartData = [15, 10, 65];
const chartColors = () => {
  //return ["rgb( 234 88 12 / 0.9)", "rgb( 234 179 8 / 0.9)", "rgb( 153 27 27 / 0.9)"]

  return [
    getColor("pending", 0.9),
    getColor("warning", 0.9),
    getColor("primary", 0.9),
  ];
};

function calculateData() {
  //@ts-ignore
  const darkMode = JSON.parse(localStorage.getItem("theme")).darkMode;
  //@ts-ignore
  const colorScheme = JSON.parse(localStorage.getItem("theme")).colorScheme;
  return {
    labels: ["Yellow", "Dark"],
    datasets: [
      {
        data: chartData,
        backgroundColor: colorScheme ? chartColors() : "",
        hoverBackgroundColor: colorScheme ? chartColors() : "",
        borderWidth: 2,
        borderColor: darkMode ? getColor("darkmode.700") : getColor("white"),
      },
    ],
  };
}

const options = computed<ChartOptions>(() => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: "83%",
  };
});
</script>

<template>
  <Chart
    :key="refresh"
    type="doughnut"
    :width="props.width"
    :height="props.height"
    :data="calculateData()"
    :options="options"
  />
</template>
